var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "trade-in-special" }, [
      _c("div", {
        staticClass: "realisteWidget",
        attrs: {
          id: "realisteWidget",
          "data-widget": "https://zk-mainstreet.realiste.ai/",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }